<template>
    <el-carousel arrow="always" :autoplay='false' :loop="false" :initial-index="initialIndex">
        <el-carousel-item v-for="item,index of DocData" :key="index">
            <img style="object-fit: contain;" :src="FileAddress + item.FilePath" width="100%" height="100%" v-if='item.FileType.toLowerCase() == "bmp" || item.FileType.toLowerCase() == "jpg" || item.FileType.toLowerCase() == "png" || item.FileType.toLowerCase() == "gif" || item.FileType.toLowerCase() == "jpeg"' />
        </el-carousel-item>
    </el-carousel>
</template>

<script>
    export default {
        name: "AttachmentImgList",
        data() {
            return {
                DocData: [],
                FileAddress: "",
                objectID: "",// 附件所属ID
                UseType: 0,// 使用类型 0:普通附件,1:标题图片，2:富文本编辑器中的图片，可自行扩展
                TableName: "",
                DispatchTime: "",
                ID:"",
                initialIndex:0
            };
        },
        methods: {
            /** 调用接口获取文件 */
            GetAttachmentList() {
                let that = this;
                console.log("GetAttachmentList")
                that.$api.post(process.env.VUE_APP_FileAddress + "Main/getDocumentInfoList?appID=" + that.$store.state.projectInfo.FileSysID
                    + "&fileSystemKey=" + that.$store.state.projectInfo.FileSysToken + "&typeID=0&objectID=" + this.objectID
                    + "&useType=" + this.UseType + "&tableName=" + this.TableName + "&dispatchTime=" + that.DispatchTime, {},
                    function (res) {
                        that.DocData = res.data;
                        that.DocData.forEach((item, index) => { if (item.ID == that.ID) { that.initialIndex = index; } });
                    },
                    function () { }
                );
            },
        },
        mounted() {
            let that = this;
            that.FileAddress = process.env.VUE_APP_FileAddress.replace('fileapi/', '');
            if (that.$route.query.objectID) { that.objectID = that.$route.query.objectID; }
            if (that.$route.query.UseType) { that.UseType = that.$route.query.UseType; }
            if (that.$route.query.TableName) { that.TableName = that.$route.query.TableName; }
            if (that.$route.query.DispatchTime) { that.DispatchTime = that.$route.query.DispatchTime; }
            if (that.$route.query.ID) { that.ID = that.$route.query.ID; }

            this.$nextTick(() => {
                setTimeout(() => {
                    that.GetAttachmentList();
                }, 300);
            });
        }
    };
</script>
<style lang="less" scoped>
    /deep/ .el-carousel__container {
        height:100vh;
        background-color:black;
    }
    /deep/ .el-carousel__arrow {
        background-color: rgba(251, 251, 253, 0.3);
    }
</style>